import GatsbyImage from 'gatsby-image';
import React from 'react';
import styled from 'styled-components';
import Checkbox from './Checkbox';
import { Colors } from './styles/Colors';
import { Body, Header5 } from './typography';

const Wrapper = styled.div`
    display: flex;
    height: 75px;

    margin: 20px 0;

    padding: 40px 20px 40px 0;

    cursor: pointer;
    
    align-items: center;

    &:hover {
        background: ${Colors.cream1};
    }

    > div:first-child {
        height: 70px;
        width: 70px;

        margin: 0 10px 0 0;
    }
`;

const AddonDetails = styled.div`
    display: flex;
    flex-direction: column;

    justify-content: center;

    padding: 0 10px;

    flex: 1;

`;


export default function AddonItem({ variant, selected, onSelect }) {
    return (
        <Wrapper onClick={onSelect}>
            <GatsbyImage fluid={variant.product?.productImage?.fluid} />
            <AddonDetails>
                <Header5>{variant.name}</Header5>
                <Body>{new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                }).format(variant.individual.price)}</Body>
            </AddonDetails>
            <Checkbox value={selected} />
        </Wrapper>)
}